export default __webpack_public_path__ + "static/media/girl_folding_hands.01337e85.png";